import { z } from "zod/v4";
const durationSchema = z.string();
const timeOptionSchema = z["enum"]([
    'default',
    'monthly'
]);
const timeDashboardSchema = z.object({
    options: timeOptionSchema.optional(),
    start: z.string().optional(),
    end: z.string().optional()
});
export { durationSchema, timeDashboardSchema, timeOptionSchema };

//# sourceMappingURL=time.js.map